import { render, staticRenderFns } from "./templateCatComponent.vue?vue&type=template&id=d1740250&"
import script from "./templateCatComponent.vue?vue&type=script&lang=js&"
export * from "./templateCatComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports